<main class="container sxkm sxkm-bg bg-error">
    <div class="row">
        <div class="col error">
            <h3>¡Lo sentimos! Tenemos un problema</h3><img class="error__img" src="../../assets/img/sura-icon-error-general.svg"
                alt="SURA SESSION ERROR" />
            <p>La información no está disponible en este momento.<br>Por favor, inténtalo nuevamente</p>
            <div class="error__button"><a class="button button-secondary" href="/">REINTENTAR</a></div>
        </div>
    </div>
</main>